//export const API = "http://localhost:5050";
// export const API = "https://api-tellytell.onrender.com";
//Paid render server 
//export const API = "https://api-tellytell-8ax2.onrender.com"

//new Our Latest

export const API = "https://api.socomott.com"

